import React from "react";

import {
  mdiFlagOutline,
  mdiSecurity,
  mdiTagMultipleOutline,
  mdiTruckDeliveryOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import FastAPI from "../../../api/FastAPI";
import { getCountryOptions } from "../../../utils/data/Countries";
import Block from "../../block/Block";
import Input from "../../form/Input";
import Select from "../../form/Select";
import Textarea from "../../form/Textarea";

import type { JSX } from "react";

import type { AppState } from "../../../reducers";

export default function ChannelDeliverySettings(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const countries = useSelector(
    (state: AppState) => state.fetchReducer.countries,
  );

  const getRatingListQuery = FastAPI.generateQuery({
    fn: FastAPI.getRatingList,
    params: [],
  });

  const { data: channelRatingList } = useQuery(getRatingListQuery);

  const channelDeliveryRegionListOptions = getCountryOptions(
    countries,
    false,
  ).map((country) => ({
    value: country.value,
    label: country.label,
  }));

  return (
    <Block title={t("channelDeliverySettings")} zIndex={1}>
      <Input
        hasCopyToClipboard
        isReadOnly
        label={t("channelDeliveryName")}
        name="channelDeliveryName"
      />
      <Textarea
        label={t("channelShortDescription")}
        name="channelShortDescription"
      />
      <Textarea label={t("channelDescription")} name="channelDescription" />
      <Select
        isClearable
        icon={<Icon path={mdiSecurity} size={0.9375} />}
        label={t("channelMainRating")}
        name="channelRating"
        options={channelRatingList}
      />
      <Input
        isReadOnly
        icon={<Icon path={mdiFlagOutline} size={0.9375} />}
        label={t("productionLanguage")}
        name="productionLanguage"
      />
      <Select
        isMulti
        isNoWrap
        icon={<Icon path={mdiTruckDeliveryOutline} size={0.9375} />}
        label={t("channelDeliveryRegion")}
        name="channelDeliveryRegions"
        options={channelDeliveryRegionListOptions}
      />
      <Input
        isNoWrap
        icon={<Icon path={mdiTagMultipleOutline} size={0.9375} />}
        label={t("channelGenre")}
        name="channelGenres"
        type="multiTag"
      />
    </Block>
  );
}
